'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlertPopover;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _layout = require('../../layout');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function AlertPopover(props) {
  var children = props.children,
      _props$topOffset = props.topOffset,
      topOffset = _props$topOffset === undefined ? 0 : _props$topOffset,
      _props$zIndex = props.zIndex,
      zIndex = _props$zIndex === undefined ? 999 : _props$zIndex;


  return React.createElement(
    _reactAddonsCssTransitionGroup2.default,
    {
      transitionName: 't-slide-from-right',
      transitionAppear: true,
      transitionAppearTimeout: 300,
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300,
      component: _layout.Box,
      position: 'fixed',
      right: 32,
      top: topOffset + 16,
      maxWidth: 400,
      alignItems: 'flex-end',
      zIndex: zIndex
    },
    React.Children.map(children, function (child) {
      return child ? React.createElement(
        _layout.Box,
        { marginBottom: 8 },
        React.cloneElement(child, { justifyContent: 'left' })
      ) : null;
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/alert/components/alert-popover.js
// module id = 304
// module chunks = 114276838955818